{
  "name": "client",
  "version": "1.5.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:UAT": "ng build --base-href / --configuration=uat",
    "build:PROD": "ng build --base-href / --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/cdk": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "^22.2.1",
    "@angular/material": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@angular/service-worker": "^22.2.1",
    "@automapper/classes": "^8.3.6",
    "@automapper/core": "^8.3.6",
    "@gerandon/ngx-material-timepicker": "^22.0.0",
    "@js-temporal/polyfill": "^0.5.1",
    "@types/luxon": "^3.7.6",
    "bootstrap": "^5.2.2",
    "detect-browser": "^5.3.0",
    "dexie": "^3.2.2",
    "help": "^3.0.2",
    "indexeddb-export-import": "^2.1.5",
    "jsqr": "^1.4.0",
    "jwt-decode": "^3.1.2",
    "konva": "^8.3.9",
    "lodash": "^4.17.21",
    "luxon": "^3.7.2",
    "mobile-drag-drop": "^3.0.0-rc.0",
    "ngx-drag-drop": "^22.1.0",
    "ngx-webcam": "^0.4.1",
    "reflect-metadata": "^0.1.13",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@types/jasmine": "~3.10.0",
    "@types/lodash": "^4.14.181",
    "@types/node": "^26.6.4",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "typescript": "~6.0.3",
    "vitest": "^5.0.0"
  }
}
